import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import reportWebVitals from './reportWebVitals';
import router from './routes';
import { AuthProvider } from './context/AuthContext';
import { CategoryProvider } from './context/CategoryContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider로 RouterProvider를 감싸서 전역 인증 상태를 제공합니다. */}
      <AuthProvider>
        {/* CategoryProvider로 RouterProvider를 감싸서 전역 카테고리 상태를 제공합니다. */}
        <CategoryProvider>
          <RouterProvider router={router} />
        </CategoryProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
